import React, { Component } from 'react';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import CommonHeaderComponent from '../../headers/CommonHeaderComponent';
import IssuesSummary from './IssuesSummary';
import AssetSummary from './AssetSummary';
import InvoiceSummary from './InvoiceSummary';
import { fetchAppConfig } from './../../../actions/appConfigActions';
import './SummaryPage.scss';

class SummaryPage extends Component {

  componentDidMount = () => {
    const { isAssetTrackingEnabled } = this.props;
    if(isAssetTrackingEnabled === "") {
      this.props.actions.fetchAppConfig();
    }
  }

  confirmSummary = () => {
    this.props.history.push({
      pathname: `/order/${this.props.match.params.id}/verifyDelivery`,
      state: { id: this.props.match.params.id, orderNumber: this.props.location.state.orderNumber }
    })
  }

  render() {
    const { state = {} } = this.props.location;
    const { isAssetTrackingEnabled } = this.props;
    return (
      <div>
        <CommonHeaderComponent title={`Summary ${state.orderNumber ? `(${state.orderNumber})` : ''}`} enableBack={true} />
        <div className="summary-container">
          <IssuesSummary />
          {isAssetTrackingEnabled && <AssetSummary /> }
          <InvoiceSummary />
          <div className="fixed-verify-section z-index-5 summary-card" onClick={() => this.confirmSummary()}>
            <div className="btn btn-green btn-expand">Confirm</div>
          </div>
        </div>
      </div>
    )
  }
}

const actions ={ fetchAppConfig }
export default withRouter(connect(
  state => ({
    isAssetTrackingEnabled: state.appConfig.asset_tracking_enabled || ""
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch)
  }),
)(SummaryPage));
